"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultValues = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const types_1 = require("./types");
/**
 * Default preferences values for app state
 */
exports.defaultValues = {
    activated: [
        bridge_schema_1.PreferenceBoolOption.ShowTools,
        bridge_schema_1.PreferenceBoolOption.ShowSaveScreenButton,
        bridge_schema_1.PreferenceBoolOption.ShowARPanel,
        bridge_schema_1.PreferenceBoolOption.ShowTipsPanel,
        bridge_schema_1.PreferenceBoolOption.BeatingHeart,
        bridge_schema_1.PreferenceBoolOption.DarkTheme,
        bridge_schema_1.PreferenceBoolOption.ShowHub,
        bridge_schema_1.PreferenceBoolOption.PrivacyNotifications,
        bridge_schema_1.PreferenceBoolOption.AutoSync,
        bridge_schema_1.PreferenceBoolOption.ShowModelUpdatesIndicators,
        bridge_schema_1.PreferenceBoolOption.ShowExportButton,
        bridge_schema_1.PreferenceBoolOption.NewScreensTooltip,
    ],
    infoBoxTabsOrder: [
        bridge_schema_1.InfoBoxTabType.Description,
        bridge_schema_1.InfoBoxTabType.BoneParts,
        bridge_schema_1.InfoBoxTabType.BoneSurfaces,
        bridge_schema_1.InfoBoxTabType.BoneLandmarks,
        bridge_schema_1.InfoBoxTabType.Motion,
        bridge_schema_1.InfoBoxTabType.CrossSections,
        bridge_schema_1.InfoBoxTabType.MuscleOI,
        bridge_schema_1.InfoBoxTabType.Models,
        bridge_schema_1.InfoBoxTabType.Innervation,
        bridge_schema_1.InfoBoxTabType.ArterialSupply,
        bridge_schema_1.InfoBoxTabType.Sutures,
        bridge_schema_1.InfoBoxTabType.Craniometrics,
        bridge_schema_1.InfoBoxTabType.OriginTrace,
        bridge_schema_1.InfoBoxTabType.BranchesTrace,
        bridge_schema_1.InfoBoxTabType.TributariesTrace,
        bridge_schema_1.InfoBoxTabType.DrainageTrace,
        bridge_schema_1.InfoBoxTabType.VideosTreatments,
        bridge_schema_1.InfoBoxTabType.VideosConditions,
        bridge_schema_1.InfoBoxTabType.VideosExercises,
        bridge_schema_1.InfoBoxTabType.VideosStretches,
    ],
    language: types_1.Language.English,
    pushNotificationsState: -1,
};
